export function getAPIBase() {
  return import.meta.env.VITE_API_URL || "http://backend.omnos.local:8000";
}

export function isMultiplePatientOrdersEnabled() {
  return import.meta.env.VITE_ENABLE_MULTIPLE_PATIENT_ORDERS === "true";
}

export function getIdealPostcodesApiKey() {
  const key = import.meta.env.VITE_IDEAL_POSTCODES_API_KEY;
  if (key) {
    return key;
  }

  if (import.meta.env.MODE === "test") {
    return "";
  }

  // Public test key — 5 lookups/day, dev only. Sign up at account.ideal-postcodes.co.uk
  // for a trial key (50 credits) and restrict it via Allowed URLs before going live.
  if (import.meta.env.DEV) {
    return "ak_test";
  }

  return "";
}

export function getStripePublishableKey() {
  let fallbackKey;
  if (import.meta.env.VITE_ENV === "production") {
    fallbackKey = "pk_live_ygEDoQpl4LjqpeOwkg0esViy009826XNSe"; // this is the key on the regenerus vercel app
  } else {
    fallbackKey = "pk_test_tUiZWf5n0ZaDjidgIiuBxNcr00sdCaUnN5";
  }
  return import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || fallbackKey;
}
